import React, { FC } from "react";
import Sticker, {
  IStickerProps,
} from "apps/website/components/base/Sticker/Sticker";
import { Theme, themeRootClassMap } from "apps/website/maps/Theme.map";
import cx from "apps/website/utils/misc/cx";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import { IPillProps, Pill } from "apps/website/components/base/Pill/Pill";

export interface ILandingPageRecipeCarouselItem {
  stickerProps: IStickerProps,
  title: string,
  description: string,
  pills: IPillProps[],
  theme?: Theme,
  containerClassName?: string,
  textSubtitleClassName?: string,
  textBodyClassName?: string,
}

const LandingPageRecipeCarouselItem: FC<ILandingPageRecipeCarouselItem> = ({
  stickerProps,
  title,
  description,
  pills,
  theme = "light",
  containerClassName,
  textSubtitleClassName,
  textBodyClassName,
}) => (
  <div className={cx(
    "h-full flex flex-col rounded-sm xl:w-full xl:p-3",
    theme === "light" && "xl:border xl:border-light-grey xl:shadow-md",
    themeRootClassMap[theme],
    containerClassName,
  )}>
    <div className="mb-2 flex justify-center xl:justify-start">
      <Sticker {...stickerProps} />
    </div>

    <div className="flex flex-col space-y-2">
      <TextSubtitle size={2} className={cx(textSubtitleClassName)} align={{ initial: "center", xl: "default" }}>{ title }</TextSubtitle>
      <TextBody size={3} className={cx(textBodyClassName)} align={{ initial: "center", xl: "default" }}>{ description }</TextBody>
    </div>

    <div className="flex flex-col justify-start flex-grow mt-2 empty:hidden">
      { pills.length > 0 && (
        <div className="xl:flex flex-wrap w-full gap-2 hidden">
          { pills.map((pill) => (
            <Pill key={pill.label} iconClassName="text-black" {...pill} />
          )) }
        </div>
      ) }
    </div>
  </div>
);

export default LandingPageRecipeCarouselItem;
